// extracted by mini-css-extract-plugin
module.exports = {"root":"Progress_root__30X_S","container":"Progress_container__2W5-S","label":"Progress_label__19_mp"};